/*

yogesh 09/29/2022 2700753823 Icon Enhancement in Side Nav
raghu 10/12/2022 2698966688 Communication history date picker alignments fixed
Prakash 26/10/2022 2698966688 Select Dropdown Alignments.
Prakash 29/10/2022 2698966688 changed font sizes.
Prakash 10/31/2022 2698966688 fixed alignment multi select field.
Prakash 11/02/2022 2698966688 Added styling spacing  for Fields.
Prakash 11/03/2022 2698966688 Added styling spacing  for cards.
Prakash 11/03/2022 2698966688 Added styling for Responsiveness TextField.
Suresh Peddavoora 11/18/2022 2700799562 Fixed Alignments for Icons in Autocomplete Dropdown
Prakash 11/21/2022 2700799562 Added padding for cards styling.
Suresh Peddavoora 11/25/2022 2699217591 Modified Styles for Select Dropdown Icon.
Ashraf 11/28/2022 2698947782 disabled styles for textfields
Guru Prasad 12/05/2022 2700430604 Added state for toggle
Suresh Peddavoora 12/06/2022 2692790263 Added Styles for Select Dropdown
Raghu 12/13/2022 2692790263 Autocomplete field font-size fixes
Rohini 12/29/2022 2692790263 removed the css properties for account summary
Prakash 02/13/2023 2698811066 card styling padding spacing changed.
// Guru Prasad 02/15/2023 2701135832 fixed styles for chips in Autocomplete field.
Suresh peddavoora 03/10/2023 2701135832 Fields alignments fixes
Suresh peddavoora 06/26/2023 2701135832 Added className.
*/

import React, {createContext, useState, useEffect} from 'react';
import {makeStyles} from '@material-ui/core';

export const ThemeContext = createContext();

const useStyles = makeStyles((theme) => ({
  lightTheme: {
    backgroundColor: 'blue',
    color: 'white',
  },
  darkTheme: {
    backgroundColor: 'black',
    color: 'white',
  },
  yellowTheme: {
    backgroundColor: 'yellow',
    color: 'white',
  },
  greenTheme: {
    backgroundColor: 'green',
    color: 'white',
  },
  redTheme: {
    backgroundColor: 'red',
    color: 'white',
  }
}));

const ThemeProvider = ({children}) => {
  const classes = useStyles();
  const [themeMode, setThemeMode] = useState('lightTheme'); // Setting default as light theme
  const [sidebarTheme, setSidebarTheme] = useState('blackSideBarTheme');
  const [showWidgetSection, setShowWidgetSection] = useState(false);
  const [labelColor, setLabelColor] = useState('#595959');
  const [sideNavSection, setSideNavSection] = useState(false);
  const [customButton, setCustomButton] = useState(false);

  useEffect(() => {
    // Setting the default as light theme
    document.documentElement.classList.add(`theme-lightTheme`);
    document.documentElement.classList.add(`sidebar-linearBlueSideBarTheme`);
  }, []);
  useEffect(() => {
    if (sidebarTheme === 'blackSideBarTheme') {
      setLabelColor('#595959');
    } else if (sidebarTheme === 'lightBlueSideBarTheme') {
      setLabelColor('#02a999');
    } else if (sidebarTheme === 'darkBlueSideBarTheme') {
      setLabelColor('#673ab7');
    } else if (sidebarTheme === 'blueSideBarTheme') {
      setLabelColor('#6200EE');
    } else if (sidebarTheme === 'redSideBarTheme') {
      setLabelColor('#B94343');
    } else if (sidebarTheme === 'greenSideBarTheme') {
      setLabelColor('#6eaf38');
    } else if (sidebarTheme === 'skyBlueSideBarTheme') {
      setLabelColor('#607d8b');
    }
  }, [sidebarTheme]);

  // Handling Themes in the application
  const toggleTheme = (theme) => {
    const classNames = document.documentElement.classList;

    const prevRadiusClass = Object.values(classNames).filter((ele) => ele.split('-')[0] === 'theme');
    prevRadiusClass.length > 0 && document.documentElement.classList.remove(prevRadiusClass[0]);
    document.documentElement.classList.add(`theme-${theme}`);
    setThemeMode(theme);
  };
  // Handling Border Radius in the application
  const toggleBorderRadius = (radius) => {
    const classNames = document.documentElement.classList;
    const prevRadiusClass = Object.values(classNames).filter((ele) => ele.split('-')[0] === 'radius');
    prevRadiusClass.length > 0 && document.documentElement.classList.remove(prevRadiusClass[0]);
    document.documentElement.classList.add(`radius-${radius}`);
  };
  // Handling SideBar Color Theme
  const toggleSideBarTheme = (theme) => {
    const classNames = document.documentElement.classList;
    const prevSideBarClass = Object.values(classNames).filter(
      (ele) => ele.split('-')[0] === 'sidebar',
    );
    prevSideBarClass.length > 0 && document.documentElement.classList.remove(prevSideBarClass[0]);
    document.documentElement.classList.add(`sidebar-${theme}`);
    setSidebarTheme(theme);
  };

  const toggleWidgetSection = () => {
    setShowWidgetSection(!showWidgetSection);
  };
  const toggleSideNavSection = () => {
    setSideNavSection(!sideNavSection);
  };

  const reusableInputStyles = makeStyles((theme) => ({
    cardStyling: {
      'whiteSpace': 'nowrap',
      'padding': '10px',
      'borderRadius': 8,
      'backgroundColor': '#ededed',
      'marginBottom': 10,
      'boxShadow':
        '0px 1px 0px rgb(0 0 0 / 10%), 0px 0px 1px rgb(0 0 0 / 10%), 0px 1px 2px rgb(0 0 0 / 10%)',
      '& .MuiTypography-h3': {
        padding: '3px 0 12px 0;',
      },
    },
    cardStyleWhite: {
      whiteSpace: 'nowrap',
      padding: '20px 15px 15px',
      borderRadius: 8,
      backgroundColor: '#fff',
      marginBottom: 10,
      boxShadow:
        '0px 1px 0px rgb(0 0 0 / 10%), 0px 0px 1px rgb(0 0 0 / 10%), 0px 1px 2px rgb(0 0 0 / 10%)',
    },
    cardStyles: {
      whiteSpace: 'nowrap',
      padding: '15px',
      borderRadius: 8,
      marginBottom: 10,
      backgroundColor: '#ededed',
      border: '2px solid #3e3e3e',
    },
    cardBordernoneStyles: {
      'whiteSpace': 'nowrap',
      'padding': '15px 10px',
      'borderRadius': '0px 0px 8px 8px',
      'backgroundColor': '#ffffff',
      'marginBottom': 10,
      'boxShadow':
        '0px 1px 0px rgb(0 0 0 / 10%), 0px 0px 1px rgb(0 0 0 / 10%), 0px 1px 2px rgb(0 0 0 / 10%)',
      '&.MuiGrid-spacing-xs-2': {
        margin: '0px -5px !important',
      },
      '& .MuiGrid-spacing-xs-2 ': {
        '& .MuiGrid-item': {
          padding: '0px 10px !important',
        },
      },
      '& .form-row': {
        '& .col': {
          paddingRight: '10px !important',
          paddingLeft: '10px !important',
        },
        '& [class*=col-]': {
          paddingRight: '10px !important',
          paddingLeft: '10px !important',
        },
      },
    },
    tabCardStyles: {
      whiteSpace: 'nowrap',
      padding: '15px',
      borderRadius: 8,
      backgroundColor: '#ededed',
      marginBottom: 10,
      boxShadow:
        '0px 1px 0px rgb(0 0 0 / 10%), 0px 0px 1px rgb(0 0 0 / 10%), 0px 1px 2px rgb(0 0 0 / 10%)',
    },
    dialoguecardStyles: {
      'padding': '0px 15px',
      '& .MuiTypography-h4': {
        fontFamily: 'articulat-cf, sans-serif !important',
      },
    },
    popper: {
      zIndex: '9999 !important',
      top: '-3px !important',
    },
    dropDown: {
      zIndex: '11 !important',
    },
    amountLabel: {
      '& .MuiOutlinedInput-inputAdornedStart': {
        paddingLeft: '0 !important',
      },
    },

    // Not using currently this class name properties //

    // labelName: {
    //   "& .MuiOutlinedInput-input": {
    //     fontSize:"0.75rem !important",
    //     color: `${labelColor} !important`,
    //     // opacity: "1 !important",
    //     fontWeight: "bold !important",
    //     margin: "15px 0 0",
    //     [theme.breakpoints.up(1920)]: {
    //       margin: "20px 0 0",
    //     },
    //   },
    //   "& fieldset": {
    //     top: "0px !important",
    //     "& legend": {
    //       display: "none !important",
    //     },
    //   },
    //   "& MuiInputBase-input.Mui-disabled": {
    //     opacity: "0.5 !important",
    //   },
    // },

    // Not using currently this class name properties //
    labelName: {
      '& .MuiOutlinedInput-input': {
        color: `${labelColor} !important`,
      },
      '& .MuiAutocomplete-tagSizeSmall .MuiChip-label': {
        color: `${labelColor} !important`,
      },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        color: `${labelColor} !important`,
      },
      '& .MuiFormLabel-root.Mui-disabled': {
        fontWeight: '500 !important',
      },
      '& .MuiInputBase-input.Mui-disabled': {
        color: '#000000d9 !important',
      },
    },

    inputLabel: {
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        fontWeight: '500 !important',
        fontSize: '0.75rem',
        color: '#fff !important',
        width: '100%',
        padding: '3px 14px',
        backgroundColor: '#696969 !important',
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
        transform: 'translate(0, 0) scale(1) !important',
        [theme.breakpoints.down('sm')]: {
          padding: '4px 14px! important',
        },
        [theme.breakpoints.up(1920)]: {
          padding: '6px 14px! important',
        },
      },
      '& .MuiOutlinedInput-inputMarginDense': {
        paddingTop: '10.5px !important',
        paddingBottom: '5.5px !important',
        [theme.breakpoints.up(1920)]: {
          paddingTop: '13.5px !important',
          paddingBottom: '6.5px !important',
          fontSize: '1rem !important',
        },
      },
    },
    AccountMessagesLabel: {
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        fontWeight: '500 !important',
        fontSize: '0.938rem',
        color: '#fff !important',
        width: '100%',
        padding: '3px 14px',
        backgroundColor: '#696969 !important',
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
        transform: 'translate(0, 0) scale(1) !important',
        [theme.breakpoints.down('sm')]: {
          fontSize: '0.813rem !important',
          padding: '4px 14px! important',
        },
        [theme.breakpoints.up(1920)]: {
          padding: '6px 14px! important',
        },
      },
      '& .MuiOutlinedInput-inputMarginDense': {
        paddingTop: '10.5px !important',
        paddingBottom: '5.5px !important',
        [theme.breakpoints.up(1920)]: {
          paddingTop: '13.5px !important',
          paddingBottom: '6.5px !important',
          fontSize: '1rem !important',
        },
      },
      '& .MuiOutlinedInput-multiline.MuiOutlinedInput-marginDense': {
        paddingTop: '3.5px',
        paddingBottom: '10.5px',
        paddingLeft: '0px',
      },
    },
    CustomDescriptionLabel: {
      '& .MuiOutlinedInput-multiline.MuiOutlinedInput-marginDense': {
        paddingLeft: '0px',
      },
    },
    textField: {
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        fontWeight: '500 !important',
        fontSize: '0.938rem',
        color: '#fff !important',
        width: '100%',
        padding: '3px 14px !important',
        backgroundColor: '#696969 !important',
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
        transform: 'translate(0, 0) scale(1) !important',
        [theme.breakpoints.down('sm')]: {
          fontSize: '0.813rem !important',
          padding: '3px 8px! important',
        },
        [theme.breakpoints.up(1920)]: {
          fontSize: '1rem !important',
          padding: '6px 14px! important',
        },
      },
      '& .MuiOutlinedInput-adornedEnd': {
        paddingRight: '40px !important',
      },
    },
    selectGender: {
      fontSize: '13px',
    },
    selectLabel: {
      '& .MuiAutocomplete-endAdornment': {
        top: '18px',
        [theme.breakpoints.up(1920)]: {
          top: '28px',
        },
        [theme.breakpoints.down('md')]: {
          top: '18px',
        },
      },
      '& .MuiSelect-iconOutlined': {
        top: '25px !important',
        [theme.breakpoints.up(1920)]: {
          top: '30px',
        },
        [theme.breakpoints.down('md')]: {
          top: '25px !important',
        },
        [theme.breakpoints.down('sm')]: {
          top: '22px !important',
        },
      },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        fontWeight: '500 !important',
        fontSize: '0.938rem',
        color: '#fff !important',
        width: '100%',
        padding: '3px 14px !important',
        backgroundColor: '#696969 !important',
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
        transform: 'translate(0, 0) scale(1) !important',
        [theme.breakpoints.down('sm')]: {
          fontSize: '0.813rem !important',
          padding: '3px 8px! important',
        },
        [theme.breakpoints.up(1920)]: {
          padding: '6px 14px! important',
        },
      },
      '& .MuiOutlinedInput-inputMarginDense': {
        paddingTop: '10.5px !important',
        paddingBottom: '5.5px !important',
        paddingRight: '50px !important',
        [theme.breakpoints.up(1920)]: {
          paddingTop: '13.5px !important',
          paddingBottom: '6.5px !important',
          fontSize: '1rem !important',
        },
      },
      '& .MuiSelect-select': {
        marginTop: '0.9375rem !important',
        paddingTop: '0.5rem !important',
        paddingBottom: '0.5rem !important',
        [theme.breakpoints.only('md')]: {
          marginTop: '0.8125rem !important',
          paddingTop: '0.5rem !important',
          paddingBottom: '0.3125rem !important',
        },
      },
    },
    actionField: {
      '& .MuiOutlinedInput-inputMarginDense': {
        [theme.breakpoints.down('md')]: {
          paddingRight: '30px !important',
        },
      },
    },
    // custom windows
    selectBox: {
      '& .MuiAutocomplete-endAdornment': {
        top: '10px !important',
      },
    },
    // custom windows
    selectdropdown: {
      '& .MuiInputBase-root': {
        'lineHeight': '0px', // making equal height with other TextFields
        '& .MuiSelect-outlined.MuiSelect-outlined': {
          margin: '15px 0 0 ',
          [theme.breakpoints.up(1920)]: {
            margin: '20px 0 0',
          },
        },
      },
      '& .MuiSelect-iconOutlined': {
        top: '18px !important',
        [theme.breakpoints.down('sm')]: {
          top: '21px !important',
        },
        [theme.breakpoints.down('md')]: {
          top: '23px !important',
        },
        [theme.breakpoints.up(1920)]: {
          top: '30px !important',
        },
      },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        fontWeight: '500 !important',
        fontSize: '0.938rem',
        color: '#fff !important',
        width: '100%',
        padding: '3px 14px !important',
        backgroundColor: '#696969 !important',
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
        transform: 'translate(0, 0) scale(1) !important',
        [theme.breakpoints.down('sm')]: {
          fontSize: '0.813rem !important',
          padding: '3px 8px! important',
        },
        [theme.breakpoints.up(1920)]: {
          fontSize: '1rem !important',
          padding: '6px 14px! important',
        },
      },
      '& .MuiOutlinedInput-inputMarginDense': {
        paddingTop: '10.5px !important',
        paddingBottom: '5.5px !important',
        paddingRight: '50px !important',
        [theme.breakpoints.up(1920)]: {
          paddingTop: '13.5px !important',
          paddingBottom: '6.5px !important',
          fontSize: '1rem !important',
        },
      },
      '& .MuiSelect-select': {
        height: '1.1876em',
      },
    },

    // Recordformat-Label-fontsize//
    recordformatLabel: {
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        [theme.breakpoints.down('md')]: {
          fontSize: '0.68rem !important',
        },
      },
    },
    // Recordformat-Label-fontsize//

    // run a report
    selectrunadropdown: {
      '& .MuiSelect-outlined.MuiSelect-outlined': {
        margin: '13px 0 0 ',
        [theme.breakpoints.up(1920)]: {
          margin: '20px 0 0',
        },
      },
      '& .MuiSelect-iconOutlined': {
        top: '25px !important',
        [theme.breakpoints.down('sm')]: {
          top: '21px !important',
        },
        [theme.breakpoints.up(1920)]: {
          top: '28px !important',
        },
      },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        fontWeight: '500 !important',
        fontSize: '0.8rem !important',
        color: '#fff !important',
        width: '100%',
        padding: '3px 14px !important',
        backgroundColor: '#696969 !important',
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
        transform: 'translate(0, 0) scale(1) !important',

        [theme.breakpoints.down('md')]: {
          fontSize: '0.75rem !important',
        },
        [theme.breakpoints.up(1920)]: {
          fontSize: '1rem !important',
          padding: '6px 14px !important',
        },
      },
      '& .MuiOutlinedInput-inputMarginDense': {
        paddingTop: '10.5px !important',
        paddingBottom: '5.5px !important',
        paddingRight: '36px !important',
        [theme.breakpoints.up(1920)]: {
          paddingTop: '13.5px !important',
          paddingBottom: '6.5px !important',
          fontSize: '1rem !important',
        },
      },
    },
    // run a report rulegroup
    selectruledropdown: {
      '& .MuiSelect-outlined.MuiSelect-outlined': {
        margin: '13px 0 0 ',
        [theme.breakpoints.up(1920)]: {
          margin: '18px 0 0',
        },
      },
      '& .MuiSelect-iconOutlined': {
        top: '25px !important',
      },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        fontWeight: '500 !important',
        fontSize: '0.8rem !important',
        color: '#fff !important',
        width: '100%',
        padding: '3px 14px !important',
        backgroundColor: '#696969 !important',
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
        transform: 'translate(0, 0) scale(1) !important',

        [theme.breakpoints.down('md')]: {
          fontSize: '0.75rem !important',
        },
        [theme.breakpoints.up(1920)]: {
          fontSize: '1rem !important',
          padding: '6px 14px! important',
        },
      },
      '& .MuiOutlinedInput-inputMarginDense': {
        paddingTop: '10.5px !important',
        paddingBottom: '5.5px !important',
        paddingRight: '10px !important',
        [theme.breakpoints.up(1920)]: {
          paddingTop: '13.5px !important',
          paddingBottom: '6.5px !important',
          fontSize: '1rem !important',
        },
      },
    },
    TextHistorydatePicker: {
      '& .MuiIconButton-root': {
        'padding': '0 !important',
        'margin': '0 !important',
        [theme.breakpoints.up(1920)]: {
          margin: '28px 0 0 !important',
        },
        ' & .MuiSvgIcon-root': {
          fontSize: '1.3rem',
        },
        [theme.breakpoints.up('lg')]: {
          marginBottom: '2px !important',
        },
      },

      '& .MuiOutlinedInput-input': {
        fontSize: '16px',
      },
      '& .MuiOutlinedInput-adornedEnd': {
        paddingRight: '6px',
      },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        fontWeight: '500 !important',
        fontSize: '0.938rem',
        color: '#fff !important',
        width: '100%',
        padding: '3px 15px',
        backgroundColor: '#696969 !important',
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
        transform: 'translate(0, 0) scale(1) !important',
        [theme.breakpoints.up(1920)]: {
          fontSize: '1rem !important',
          padding: '6px 14px! important',
        },
      },
      '& .MuiOutlinedInput-inputMarginDense': {
        paddingTop: '10.5px !important',
        paddingBottom: '5.5px !important',
        [theme.breakpoints.up(1920)]: {
          paddingTop: '13.5px !important',
          paddingBottom: '6.5px !important',
          fontSize: '1rem !important',
        },
      },
      '& .MuiFormHelperText-root': {
        top: '55px !important',
      },
    },
    datePicker: {
      '& .MuiIconButton-root': {
        'padding': '0 !important',
        'margin': '22px 0 0 !important',
        [theme.breakpoints.up(1920)]: {
          margin: '28px 0 0 !important',
        },
        ' & .MuiSvgIcon-root': {
          fontSize: '1.3rem',
        },
        [theme.breakpoints.up('lg')]: {
          marginBottom: '2px !important',
        },
      },

      '& .MuiOutlinedInput-input': {
        fontSize: '16px',
      },
      '& .MuiOutlinedInput-adornedEnd': {
        paddingRight: '6px',
      },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        fontWeight: '500 !important',
        fontSize: '0.938rem',
        color: '#fff !important',
        width: '100%',
        padding: '3px 15px',
        backgroundColor: '#696969 !important',
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
        transform: 'translate(0, 0) scale(1) !important',
        [theme.breakpoints.up(1920)]: {
          padding: '6px 14px! important',
        },
      },
      '& .MuiOutlinedInput-inputMarginDense': {
        paddingTop: '10.5px !important',
        paddingBottom: '5.5px !important',
        [theme.breakpoints.up(1920)]: {
          paddingTop: '13.5px !important',
          paddingBottom: '6.5px !important',
          fontSize: '1rem !important',
        },
      },
      '& .MuiFormHelperText-root': {
        top: '55px !important',
      },
    },
    checkBox: {
      marginRight: 8,
      padding: 9,
      [theme.breakpoints.down('md')]: {
        marginRight: 0,
        padding: 5,
      },
    },
    // DragAndDropWrapper: {
    //   "& .dropzone": {
    //     flexDirection: "row !important",
    //     alignItems: "center !important",
    //     padding: "12px !important",
    //     border: `2px dashed #5c5c5c`,
    //     backgroundColor: `transparent`,
    //     "& > p": {
    //       padding: "0px 10px 0px 0px",
    //     },
    //   },
    // },
    // radioGroup: {
    //   fontWeight: "bold",
    //   fontSize: "16px !important",
    // },
    listBox: {
      overflowY: 'auto !important',
      overflowX: 'hidden !important',
    },
    popover: {
      pointerEvents: 'none',
    },
    paper: {
      padding: theme.spacing(1),
    },
    toolTip: {
      'zIndex': '10 !important',
      '& .MuiTooltip-tooltipPlacementBottom': {
        margin: '5px !important',
      },
    },
    buttonRoot: {
      'lineHeight': 1.75,
      [theme.breakpoints.down('md')]: {
        lineHeight: 1.5,
        padding: '6px 15px !important',
      },
      '& .MuiButton-label': {
        'fontSize': '0.813rem',
        [theme.breakpoints.down('md')]: {
          fontSize: '0.688rem !important',
          letterSpacing: 1,
        },
        '& .MuiSvgIcon-root': {
          [theme.breakpoints.down('md')]: {
            fontSize: '1.1rem !important',
          },
        },
      },
    },
    option: {
      fontFamily: 'articulat-cf, sans-serif !important',
      padding: '6px 16px',
      fontSize: '12px',
      [theme.breakpoints.down('md')]: {
        padding: '6px 10px',
      },
    },
    dashboard: {
      padding: 0,
      marginBottom: 15,
      color: '#ffffff',
    },
    placementDate: {
      [theme.breakpoints.up('md')]: {
        '& .MuiOutlinedInput-input': {
          padding: '10.5px 5px',
        },
      },
    },
    globalButtons: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '10px',
    },

    cardHeight: {
      minHeight: '480px',
    },
    systemNotesWrapper: {
      '& > .MuiPaper-root > .MuiCollapse-root > .MuiCollapse-wrapper > .MuiCollapse-wrapperInner > .MuiAccordion-region > .MuiAccordionDetails-root':
        {
          display: 'unset',
        },
    },
    mapRuleGroup: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },

    globalPopup: {
      margin: '0 10px',
    },

    heading: {
      margin: '10px 15px',
    },
    searchText: {
      color: '#000000',
      fontSize: '16px',
      fontWeight: '900',
      marginBottom: '0',
    },
    firstCardDiv: {
      paddingRight: 0,
      paddingLeft: 0,
    },
    secondCardDiv: {
      paddingRight: 0,
      paddingLeft: 0,
    },
    letterControlButtons: {
      justifyContent: 'center',
      margin: '10px 0 15px',
    },
    htmlRadio: {
      '& .Mui-checked': {
        color: '#6200EE !important',
      },
      '& .MuiIconButton-colorSecondary': {
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
    },
    formRoot: {
      '& .MuiFormControl-root ': {
        '&.MuiFormControlLabel-root': {
          marginBottom: '0px !important',
          marginRight: '0px !important',
        },
      },
    },

    // letterControlButtons: {
    //   justifyContent: "center",
    //   margin: "10px 0 15px",
    // },
    // mapField: {
    //   margin: "0 12px",
    // },
    // globalButtons: {
    //   display: "flex",
    //   alignItems: "center",
    //   justifyContent: "space-between",
    //   marginBottom: "10px",
    // },
    globalField: {
      padding: '6px 8px',
      color: '#ffffff',
      marginBottom: '10px',
    },
    disabling: {
      opacity: '0.5 !important',
    },
    legend: {
      backgroundColor: '#ededed',
      position: 'absolute',
      top: -10,
      left: 15,
      color: '#056c93',
      padding: '2px 4px',
      fontWeight: 700,
      width: 'auto',
      fontSize: '14px',
      margin: '2px 0 10px',
      display: 'inline-block',
      whiteSpace: 'nowrap',
    },
    radioGroup: {
      'fontWeight': 'bold',
      'fontSize': '16px !important',
      '& .MuiFormControlLabel-root': {
        marginRight: '4px !important',
      },
    },
    DragAndDropWrapper: {
      '& .dropzone': {
        'flexDirection': 'row !important',
        'alignItems': 'center !important',
        'padding': '12px !important',
        'border': `2px dashed #5c5c5c`,
        'backgroundColor': `transparent`,
        '& > p': {
          padding: '0px 10px 0px 0px',
        },
      },
    },
    radioLabel: {
      'fontWeight': '500 !important',
      'fontSize': '0.834rem !important',
      'color': '#fff !important',
      'width': '100%',
      'padding': '3px 15px !important',
      'backgroundColor': '#696969',
      'borderTopLeftRadius': '4px',
      'borderTopRightRadius': '4px',
      'transform': 'translate(0, 0) scale(1) !important',
      'marginBottom': '3px !important',
      [theme.breakpoints.down('lg')]: {
        borderTopLeftRadius: '0 !important',
        borderTopRightRadius: '0 !important',
      },
      '& ..MuiFormControlLabel-root': {
        marginRight: '5px !important',
      },
    },
    outputType: {
      'border': '1px solid #000',
      'height': '70px',
      'paddingLeft': '0px !important',
      'paddingRight': '0px !important',
      'borderRadius': '5px',
      'marginLeft': '5px',
      [theme.breakpoints.down('md')]: {
        height: '78px',
      },
      // [theme.breakpoints.only("lg")]: {
      //   marginLeft:"50px",
      // },
      ' & .MuiFormGroup-row': {
        'paddingLeft': '14px',
        '& .MuiFormControlLabel-root': {
          [theme.breakpoints.down('md')]: {
            marginRight: '20px',
          },
        },
      },
    },
    buttonRoot2: {
      backgroundColor: '#D1D1D1',
      fontSize: '10px',
      borderRadius: '15px',
      marginTop: '19px',
      marginLeft: '8px',
      padding: '1px 16px !important',
      [theme.breakpoints.down('lg')]: {
        fontSize: '9px',
        marginTop: '18px',
      },
    },
    addGlobalButtons: {
      textAlign: 'right',
      marginBottom: '7px',
    },
    filterGroupButton: {
      backgroundColor: '#D1D1D1',
      fontSize: '10px',
      borderRadius: '15px',
      marginTop: '19px',
      padding: 0,
    },
    multiselectlabel: {
      '& .MuiAutocomplete-tagSizeSmall': {
        'marginTop': '5px !important',
        'marginBottom': '5px !important',
        'height': '20px !important',
        [theme.breakpoints.up(1920)]: {
          marginTop: '22px !important',
        },
        '& .MuiChip-label': {
          // overflow:"visible !important",
          fontWeight: 'bold !important',
        },
      },
      '& .MuiAutocomplete-tag': {
        marginTop: '15px !important',
        justifyContent: 'flex-start',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '250px',
      },
      '& .MuiAutocomplete-inputRoot[class*=MuiOutlinedInput-root]': {
        padding: '10px 50px 0 8px !important',
      },
    },
    MTableAlign: {
      '& .MuiAccordionDetails-root': {
        display: 'inherit',
      },
    },
    mapRuleButton: {
      padding: '6px 5px !important',
    },
    iconSearch: {
      cursor: 'pointer',
    },
    checkRoot: {
      // margin: 0,
      marginTop: 5,
      marginLeft: -11,
      whiteSpace: 'pre-line',
      [theme.breakpoints.down('md')]: {
        ' & .MuiSvgIcon-root': {
          fontSize: '1.2rem',
        },
      },
    },

    labelRoot: {
      '& .MuiTypography-root': {
        whiteSpace: 'pre-line',
      },
    },
    // select-field-css-starts//
    selectField: {
      '& .MuiFormLabel-root': {
        fontSize: '14px !important',
      },
      '& .MuiSelect-select': {
        padding: '0px !important',
        paddingLeft: '14px !important',
        minHeight: '2.45em !important',
        fontSize: '14px !important',
        fontFamily: 'articulat-cf, sans-serif !important',
        color: '#595959',
      },
      '& .MuiSelect-nativeInput': {
        padding: '10px !important',
      },
      '& .MuiInputLabel-outlined': {
        transform: 'translate(14px, 10px) scale(1) !important',
      },
      '& .MuiInputLabel-shrink': {
        transform: 'translate(14px, -6px) scale(0.75) !important',
      },
    },
    // select-field-css-ends//
  }));
  const appliedTheme = classes[themeMode];
  const appliedFont = classes[sidebarTheme];
  const value = {
    themeMode,
    sidebarTheme,
    toggleTheme,
    toggleBorderRadius,
    toggleSideBarTheme,
    appliedTheme,
    showWidgetSection,
    toggleWidgetSection,
    appliedFont,
    reusableInputStyles,
    labelColor,
    toggleSideNavSection,
    sideNavSection,
    setSideNavSection,
    setShowWidgetSection,
    customButton,
    setCustomButton,
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export default ThemeProvider;
